import { forwardRef, useState } from 'react';

// ICONS
import { Search, Delete } from 'lucide-react';

// COMPONENTS
import SearchModal from './searchModalComponent';

const SearchBar = forwardRef(({ value, onChange, isGlobalSearch = false, ...props }, ref) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const searchBarRef = ref;

    const handleClear = () => {
        onChange({ target: { value: '' } });
    };

    const handleClick = () => {
        if (isGlobalSearch) {
            setIsModalOpen(true);
        }
    };

    return (
        <>
            <div 
                ref={searchBarRef}
                className="flex items-center w-full sm:w-auto sm:flex-1 bg-gris/40 dark:bg-dark-secondary rounded-full px-4 py-2"
                onClick={handleClick}
            >
                <Search className="text-noir dark:text-blanc" size={24} />

                <input
                    type="text"
                    placeholder='Rechercher...'
                    className="bg-transparent focus:outline-none w-full text-body-xs text-noir dark:text-blanc placeholder-noir/40 dark:placeholder-blanc pl-2"
                    value={value}
                    onChange={onChange}
                    {...props}
                />

                {value && (
                    <Delete
                        className="ml-2 text-noir dark:text-blanc hover:text-orange dark:hover:text-orange cursor-pointer"
                        size={24}
                        onClick={handleClear}
                    />
                )}
            </div>

            {isGlobalSearch && (
                <SearchModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    searchValue={value}
                    onSearch={(newValue) => onChange({ target: { value: newValue } })}
                    searchBarRef={searchBarRef}
                />
            )}
        </>
    );
});

export default SearchBar;